import SocketEvent from "./abstract/SocketEvent"
import {
    GetLinkingRequestsSpecification,
    OnLinkingRequestArrivedEventKey,
    OnLinkingRequestArrivedEventResponsePayload
} from "pokal_api"
import { dispatchThunk } from "../redux/thunk/thunkify"
import { nothing } from "../util/void"
import { showNotification } from "../redux/Notification"

const OnLinkingRequestArrivedEvent: SocketEvent<OnLinkingRequestArrivedEventResponsePayload> =
    new SocketEvent(
        OnLinkingRequestArrivedEventKey,
        (args, input, dispatch) => {
            dispatchThunk(dispatch, GetLinkingRequestsSpecification, nothing)
            showNotification(
                dispatch,
                "Neue Verbindungsanfrage",
                `Sie haben soeben eine neue Verbindungsanfrage von Patient:in ${args.name} erhalten.`
            )
        }
    )

export default OnLinkingRequestArrivedEvent
